import { mainSlide } from "./modules/main-slide.js";
mainSlide();
import { newProductsSlide } from "./modules/new-products-slide.js";
newProductsSlide();
import { saleProductsSlide } from "./modules/sale-products-slide.js"; saleProductsSlide();
// -----------------------------------------------------------------------------
